// extracted by mini-css-extract-plugin
export default {"main":"Confirmation_main__89euy","main-btn":"Confirmation_main-btn__BnYpW"};